export enum MileageMotorcycleEnum {
    LessThan4000 = '3999',
    Between4000And8000 = '7999',
    Between8000And12000 = '11999',
    Between12000And16000 = '15999',
    Between16000And20000 = '19999',
    Between20000And30000 = '29999',
    MoreThan30000 = '30001',
}
